import { readAllSharedFilesFromRepo } from '../code-file-store'

function getSharedFilesArray() {
  return Object.values(readAllSharedFilesFromRepo()).sort((a, b) => b.loadTs - a.loadTs)
}

export { getSharedFilesArray }